<template>
    <div class="codewrapper" v-if="code.length > 0">
        <span v-if="link.length > 0" class="codelink" v-on:click="openEmbeddedIframe(link)">{{code}}</span>
        <span v-else class="codetext">{{code}}</span>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-property-decorator"
    import EmbeddedPdfModel from "../models/embeddedPdfModel"

    @Component
    export default class CodeLink extends Vue {
        @Prop() readonly code!: string
        @Prop() readonly column!: string
        @Prop() readonly dependantCode: string | undefined
        @Prop() readonly index!: string

        link: string = ""

        created() {
            if (this.code.length > 0 && this.column.length > 0) {
                let obj
                if (this.dependantCode !== undefined) {
                    obj = this.$store.getters.columnCodeLinks.find(x => x.sarake.toLowerCase() === this.column?.toLowerCase() && x.koodi.toLowerCase() === this.dependantCode?.toLowerCase())
                } else {
                    obj = this.$store.getters.columnCodeLinks.find(x => x.sarake.toLowerCase() === this.column?.toLowerCase() && x.koodi.toLowerCase() === this.code?.toLowerCase())
                }

                if (obj !== undefined) {
                    this.link = this.$store.getters.baseHref + "/content/VAKHakuFiles" + obj.linkki
                }
            }
        }

        openEmbeddedIframe(pdfUrl: string): void {
            // muuten tehd��n uusi rivi
            let hasDuplicate: boolean = false
            const currentPdfs: Array<EmbeddedPdfModel> = [...this.$store.getters.embeddedPdfFiles]
            for (let i = 0; i < currentPdfs.length; i++) {
                if (currentPdfs[i].index === this.index) {
                    hasDuplicate = true
                }
            }
            if (hasDuplicate) {
                const oldPdf: number = currentPdfs.findIndex(e => e.index === this.index)
                currentPdfs.splice(oldPdf, 1)
                currentPdfs.push(new EmbeddedPdfModel(pdfUrl, this.index))
            } else {
                currentPdfs.push(new EmbeddedPdfModel(pdfUrl, this.index))
            }

            this.$store.dispatch("setEmbeddedPdfFiles", currentPdfs)
        }
    }

</script>

<style scoped>
    .codewrapper {
        display: block;
    }

        .codewrapper > a.codelink {
            display: inline;
        }

        .codewrapper > span.codetext {
            display: inline;
        }

    span.codelink {
        color: #026273;
        font-weight: 600;
        background-image: linear-gradient(#80C1C2 50%, #FFFFFF 50%);
        background-size: 0.125rem 0.333rem;
        background-position: 0px 1.15em;
        background-repeat: repeat-x;
        text-decoration: none;
        cursor: pointer;
    }

        span.codelink:hover {
            color: #026273;
            font-weight: 600;
            text-decoration: none;
            background-image: linear-gradient(#026273 50%, #FFFFFF 50%);
        }
</style>
